<template>
    <div class="building-accessControl">
        <div class="title">
            <div class="relation" @click="dialogAccessControl = true">关联门禁</div>
            <div :class="{ cancelRelation: true, updateActive: updateActiveFlag }" @click="cancelRelation">
                <span>取消关联</span>
            </div>
        </div>
        <div class="accessControl-box">
            <div class="accessControlCard" v-for="item in relationAccessList" :key="item.id">
                <div class="accessControlCard-left">
                    <el-checkbox v-model="item.checkedFlag" style="position:absolute; left:10px; top:10px"
                        @change="checkChange"></el-checkbox>
                    <img src="../../assets/images/public/accessControl-pic.png">
                </div>
                <div class="accessControlCard-right">
                    <h6>{{ item.nick_name ? item.nick_name : '-' }}</h6>
                    <p>所属楼宇：<span>{{ item.floor_name ? item.floor_name : '-' }}</span></p>
                </div>
            </div>
        </div>
        <paging v-if="total > 12" :totalCompone="total" @changePage="changePage"></paging>
        <el-dialog v-model="dialogAccessControl" title="关联门禁" width="30%" :before-close="handleClose">
            <el-form :model="form" :rules="rules" label-width="120px">
                <div class="select-tips">关联楼层：{{ floorData.name }}层</div>
                <div class="select-box">
                    <el-form-item label="门禁" prop="selectRules">
                        <el-select v-model="form.region" @change="selcetChange" multiple clearable collapse-tags
                            style="width: 240px" placeholder="选择门禁">
                            <el-option v-for="item in accessControlList" :key="item.id" :label="item.nick_name"
                                :value="item.id" :disabled="item.disabled" />
                        </el-select>
                    </el-form-item>
                </div>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogAccessControl = false">取消</el-button>
                    <el-button type="primary" @click="confirm">确认</el-button>
                </span>
            </template>
        </el-dialog>
        <!-- 取消关联弹窗 -->
        <dialogs :dialogVisibles="unbindDialogs" msg="取消关联将影响机器人通过门禁任务，确认取消吗？" title="取消关联" @off="OFF" @on="ON"
            buttonColor="#F5222D" name="footer"></dialogs>
    </div>
</template>

<script lang="ts">
import { doorQuery } from "@/apis/accessControl";
import { reactive, ref, toRefs, defineComponent, onMounted, watch, onBeforeUnmount, } from "vue";
import { bindingAccess, unbindingAccess } from '@/apis/building'
import { ElMessage } from "element-plus";
import dialogs from '@/components/dialogs/dialogs.vue'
import paging from '@/components/paging/paging.vue'

export default defineComponent({
    components: {
        dialogs,
        paging
    },
    props: {
        floorData: {
            type: Object,
            default: ''
        }
    },
    setup(props) {
        const state = reactive({
            total: 0,
            unbindDialogs: false,
            centerDialogVisible: false,
            updateActiveFlag: false,
            value: '',
            numbers: '',
            unbindData: '',
            dialogAccessControl: false,
            relationAccessList: [] as any,
            form: {
                region: '',
            },
            rules: {
                selectRules: [{ required: true, message: 'Please select Activity zone', trigger: 'blur', }]
            },
            accessControlList: [

            ] as any,
            options: [

            ],
            params: {
                floor_id: props.floorData.ID,
                pageSize: 12,
                page: 1,
                limit: true
            },
            // 页码切换
            changePage(val: number) {
                state.params.page = val
                state.relationAccessQuery()
            },
            checkChange(val: any) {
                console.log('111', val)
                state.unbindData = ''
                state.relationAccessList.forEach((item: any) => {
                    if (item.checkedFlag) {
                        state.unbindData += item.id + ','
                    }
                })
                if (state.unbindData) {
                    state.updateActiveFlag = true
                } else {
                    state.updateActiveFlag = false
                }
            },
            selcetChange(val: any) {
                console.log('选中的指', val)
                state.numbers = ''
                if (val.label > 1) {
                    val.forEach((item: any) => {
                        state.numbers += item + ','
                    })
                } else {
                    state.numbers = val
                }

            },
            handleClose() {
                state.dialogAccessControl = false
            },
            confirm() {

                bindingAccess(state.numbers, props.floorData.ID).then((res: any) => {
                    console.log('关联门禁结果', res)
                    if (res.code == 200) {
                        state.relationAccessQuery()
                        state.dialogAccessControl = false
                        ElMessage({
                            message: "关联门禁成功",
                            type: "success",
                        })
                    } else {
                        ElMessage.error(`${res.msg}`)
                    }
                })
            },
            cancelRelation() {
                if (state.unbindData) {
                    state.unbindDialogs = true
                } else {
                    return
                }
            },
            OFF() {
                state.unbindDialogs = false
            },
            ON() {
                unbindingAccess(state.unbindData).then((res: any) => {
                    console.log('解绑结果', res)
                    if (res.code == 200) {
                        state.relationAccessQuery()
                        state.unbindDialogs = false
                        ElMessage({
                            message: "门禁解绑成功",
                            type: "success",
                        })
                    } else {
                        ElMessage.error(`解绑失败：${res.msg}`)
                    }
                })
            },
            // 查询全部门禁
            accessControlQuery() {
                let params = {
                    floor_id: '-1',
                    pageSize: 12,
                    page: 1,
                    limit: true
                }
                doorQuery(params).then((res: any) => {
                    console.log('全部门禁查询', res)
                    res.data.list.forEach((item: any) => {
                        if (item.floor_id != '' || item.floor_id) {
                            item.disabled = true
                        } else {
                            item.disabled = false
                        }
                    })
                    state.accessControlList = res.data.list
                })
            },
            // 查询关联的门禁
            relationAccessQuery() {

                doorQuery(state.params).then((res: any) => {
                    console.log('关联门禁查询', res)
                    state.total = res.data.total
                    if (res.data.list.length > 0) {
                        res.data.list.forEach((item: any) => {
                            item.checkedFlag = false
                        });
                    }
                    state.relationAccessList = res.data.list
                })
            },
            init() {
                state.relationAccessQuery()
                state.accessControlQuery()
            }
        })

        watch(() => props.floorData, (newVal, oldVal) => {
            console.log('新数据', newVal)
            console.log('旧数据', oldVal)
            if (newVal.floorFlag) {
                state.init()
            } else {
                return
            }
        })

        onMounted(() => {
            console.log('父组件数据', props)
            state.init()
        })

        return {
            ...toRefs(state)
        }
    }
})
</script>

<style lang="scss" scoped>
h6,
p {
    padding: 0;
    margin: 0;
}

.building-accessControl {
    width: 100%;
    height: 686px;
    overflow-x: hidden;

    .title {
        position: relative;
        right: -78%;
        display: flex;
        width: 100%;

        .relation {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 102px;
            height: 32px;
            background: #1890FF;
            border-radius: 2px;
            font-size: 14px;
            color: #FFFFFF;
            margin-right: 10px;
            cursor: pointer;

        }

        .cancelRelation {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 88px;
            height: 32px;
            background: #FFFFFF;
            border-radius: 2px;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.85);
            border: 1px solid #D9D9D9;
            opacity: 0.3;
            cursor: pointer;

        }

        .updateActive {
            background: #1890FF;
            opacity: 1;
            border: none;

            span {
                color: #FFFFFF;
            }
        }
    }
}

.accessControl-box {
    width: 100%;
    height: 660px;
    background: #FFFFFF;
}

.accessControlCard {
    margin-left: 2px;
    margin-top: 20px;
    margin-right: 23px;
    display: inline-block;
    width: 312px;
    height: 200px;
    background: #FFFFFF;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
    border-radius: 4px;

    .accessControlCard-left {
        position: relative;
        display: inline-block;
    }

    .accessControlCard-right {
        display: inline-block;
        position: relative;
        top: -73px;
        left: 20px;

        h6 {
            margin-bottom: 30px;
            height: 20px;
            width: 140px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        p {
            height: 18px;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.45);
            line-height: 18px;
            margin-bottom: 5px;

            img {
                position: relative;
                top: 3px;
                margin-left: 10px;
            }
        }
    }
}

.from-box {
    width: 500px;
    height: 277px;
    border: 1px solid #D9D9D9;
    border-radius: 2px;

    .from-box-title {
        display: flex;
        align-items: center;
        height: 40px;
        background: #FAFAFA;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);

        .buildingName {
            margin-left: 30px;
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            line-height: 20px;
        }

        .ladderId {
            margin-left: 60px;
        }
    }

    .from-box-tl {
        display: flex;
        align-items: center;
        height: 40px;
        background: #FFFFFF;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);

        .name {
            margin-left: 30px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.65);
        }

        .checkID {
            margin-left: 139px;
        }

        .el-select {
            height: 36px;
        }
    }
}
</style>